import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { JobLog } from './models/job-log.model';
import { JobLogFilter } from './models/job-log-filter.model';
import { JobLogsService } from './job-logs.service';
import { JobLogDetailModalComponent } from './job-log-detail-modal/job-log-detail-modal.component';
import { ApiResponse } from '../../../shared/models/apiResponse.model';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-job-logs',
  templateUrl: './job-logs.component.html',
  styleUrls: ['./job-logs.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class JobLogsComponent implements OnInit {
  @ViewChild(JobLogDetailModalComponent) logDetailModal: JobLogDetailModalComponent;

  public isLoading = false;

  public jobLogs: JobLog[] = [];

  public columnMode = ColumnMode;
  public isRerendering = false;
  public filterText = '';

  public filter: JobLogFilter = {
    searchText: '',
    logTypeId: null,
    logTypeName: null,
    startDate: null,
    endDate: null,
    userId: null,
    userName: null,
    errorsOnly: false
  }

  constructor(
    private jobLogsService: JobLogsService,
    private toastrService: ToastrService
  ) { }

  ngOnInit() {
    this.isLoading = true;

    this.resetFilters();

    this.getJobLogs();
  }

  private rerenderTable() {
    this.isRerendering = true;
    setTimeout(() => this.isRerendering = false, 500);
  }

  getJobLogs() {
    this.isLoading = true;
    this.jobLogs = [];

    this.jobLogsService.getJobLogs(this.filter)
      .subscribe(
        (resp: ApiResponse<Array<JobLog>>) => {
          if (resp.data) {
            this.jobLogs = resp.data;
            this.rerenderTable();
          }

          if (resp.successful && resp.message) {
            this.toastrService.info(resp.message);
          }

          if (!resp.successful && resp.message) {
            this.toastrService.error(resp.message);
          }

          this.isLoading = false;
        },
        (err) => {
          console.error(err);
          this.toastrService.error(err);
          return Observable.of(null);
        },
        () => {
          this.isLoading = false;
        }
      )
  }

  showDetails(jobLog: JobLog) {
    this.logDetailModal.open(jobLog);
  }

  get hasFilters() {
    return this.filter.searchText.trim() ||
      this.filter.startDate ||
      this.filter.endDate ||
      this.filter.logTypeId ||
      this.filter.userId ||
      this.filter.errorsOnly === true;
  }

  resetFilters() {
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 1); // Default to last day's logs

    this.filter = {
      searchText: '',
      logTypeId: null,
      logTypeName: null,
      startDate: startDate,
      endDate: new Date(),
      userId: null,
      userName: null,
      errorsOnly: false
    }

    this.getJobLogs();
  }

  filterByDate() {
    this.getJobLogs();
  }

  filterByLogType(jobLog: JobLog) {
    this.filter.logTypeId = jobLog.logTypeId;
    this.filter.logTypeName = jobLog.logType;

    this.getJobLogs();
  }

  filterByUser(jobLog: JobLog) {
    this.filter.userId = jobLog.userId;
    this.filter.userName = jobLog.userName;

    this.getJobLogs();
  }

  filterByErrorsOnly() {
    this.getJobLogs();
  }

  removeTypeFilter() {
    this.filter.logTypeId = null;
    this.filter.logTypeName = null;

    this.getJobLogs();
  }

  removeUserFilter() {
    this.filter.userId = null;
    this.filter.userName = null;

    this.getJobLogs();
  }

  public refresh() {
    this.getJobLogs();
  }

  public copyToClipboard(row: JobLog) {
    (navigator as any).clipboard.writeText(row.userId);
    this.toastrService.success('User ID copied to clipboard.');
  }

  getTimestampString(timestamp: Date) {
    const date = new Date(timestamp);
    const utcDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));

    return `${utcDate.toLocaleDateString()} ${utcDate.toLocaleTimeString()}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/developer/logs/job-logs/job-logs.component.ts